import axios from "./defaultClient";

const nameSpace = "/ep/v1/blogs";

export const GetBlogPosts = async (args) => {
  return await axios.get(nameSpace + "/", {
    params: args,
  });
};
